import React from 'react';
import { RouterProvider } from "react-router";
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from "./utils/queryClient";
import router from './router';
import { ReactNotifications } from 'react-notifications-component'
import { CableProvider } from './contexts/cable';
import { ApiErrorProvider, useApiError } from './contexts/apiError';
import ErrorBoundary from './components/common/ErrorBoundary';
import ApiUnavailablePage from './components/common/ApiUnavailablePage';
import useTokenExpirationMonitor from './hooks/useTokenExpirationMonitor';
import { ThemeProvider } from './theme/ThemeProvider';
import { LocaleProvider } from './i18n/LocaleProvider';

import './App.scss';

/**
 * AppContent - Inner component that uses hooks requiring providers
 * Monitors token expiration and manages automatic logout
 */
const AppContent = () => {
  useTokenExpirationMonitor();
  const { hasApiError } = useApiError();

  // Show API unavailable page when there's a network or server error
  if (hasApiError) {
    return (
      <>
        <ReactNotifications />
        <ApiUnavailablePage />
      </>
    );
  }

  return (
    <>
      <ReactNotifications />
      <RouterProvider router={router} />
    </>
  );
};

const App = () => {
  return (
    <ErrorBoundary>
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <ApiErrorProvider>
            <CableProvider>
              <LocaleProvider>
                <ThemeProvider>
                  <AppContent />
                </ThemeProvider>
              </LocaleProvider>
            </CableProvider>
          </ApiErrorProvider>
        </QueryClientProvider>
      </React.StrictMode>
    </ErrorBoundary>
  );
};

export default App;
